import Blue from "~/core";
import { addEvents } from "../utils";

new Blue({
  name: "Search Dropdown",
  selector: ".listing-search__filter",
  setup(dropdown) {
    let url = window.location.href;
    let params = new URLSearchParams(document.location.search);
    
    let submitSearchButton = document.querySelector(
      ".listing-search__search-icon"
    );
    let submitSearchInput = document.querySelector(".search-field");
    let validText = document.querySelector(".listing-search__validation");
    let submitClear = document.querySelector(".listing-search__clear");
    let clearAlls = dropdown.querySelectorAll('[data-clear-for]')
    submitSearchInput.value = params.get("text");

    const clearSearch = (e) => {
      window.location.hash = "";
      window.location = window.location.href.split("?")[0] + "#results";
    };

    const clearFliter = (e) => {
      const clickedFilter = e.target.getAttribute("data-clear-for")
      if(params.has(clickedFilter.toLowerCase())){
        params.delete(clickedFilter.toLowerCase());
        params.delete('page');
        window.location = `${window.location.href.split('?')[0]}?${params}#results`;
      }
    };

    const submitSearch = (e) => {
      let query = submitSearchInput.value;
      let currentUrl = window.location.href.split("#")[0];

      if (query != "") {
        params.delete("page");
        params.set("text", query);
        window.location = `${currentUrl.split("?")[0]}?${params}#results`;
      } else {
        validText.style.display = "block";
      }
    };

    const toggleDropdown = (e) => {
      let clickedFilter = e.srcElement;
      let activeDropdowns = document.querySelectorAll(".listing-search__filter[data-active]");
      let dropdownDiv = clickedFilter.firstElementChild;
      if(e.target.classList.contains('listing-search__filter')){
        activeDropdowns.forEach((element) => {
          if (element != clickedFilter) {
            let elementDropdownDiv = element.firstElementChild;
            element.toggleAttribute("data-active");
            elementDropdownDiv.toggleAttribute("data-active");
          }
        });
  
        clickedFilter.toggleAttribute("data-active");
        dropdownDiv.toggleAttribute("data-active");
      }
    };

    const closeDropdown = (e) => {
      let isFilter = e.srcElement.classList.contains("listing-search__filter");
      if (isFilter === false) {
        let activeDropdowns = document.querySelectorAll("[data-active]");
        activeDropdowns.forEach((element) => {
          element.removeAttribute("data-active");
        });
      }
    };

    addEvents(submitSearchInput, "enter enter.prevent", submitSearch);
    addEvents(dropdown, "click ", toggleDropdown);
    addEvents(submitSearchButton, "click", submitSearch);
    addEvents(window, "click", closeDropdown);
    addEvents(clearAlls, "click", clearFliter);

    if (params.has("text") || params.has("topic") || params.has("type")) {
      submitClear.style.display = "block";
      addEvents(submitClear, "click", clearSearch);
    }
  },
});
